import React from 'react';
import PropTypes from 'prop-types';

import './Avatar.css';

/**
 * CSS-driven circular avatar that fills its parent container.
 * Parent should control width/height via CSS (responsive breakpoints).
 */
export default function Avatar({ user, className = '', border, loading = 'lazy' }) {
  const userInitials = (user && user.nickname ? user.nickname : '').slice(0, 2) || '';
  const style = {
    border: border || undefined,
  };

  if (user && user.resizedSmallImage) {
    return (
      <div className={`Avatar ${className}`}>
        <img
          className="Avatar-image"
          loading={loading}
          width="96"
          height="96"
          alt=""
          src={user.resizedSmallImage}
          style={style}
        />
      </div>
    );
  }

  return (
    <div className={`Avatar ${className}`}>
      <span className="Avatar-image Avatar-image--missing" style={style}>
        {userInitials}
      </span>
    </div>
  );
}

Avatar.propTypes = {
  user: PropTypes.shape({
    nickname: PropTypes.string,
    resizedSmallImage: PropTypes.string,
  }).isRequired,
  className: PropTypes.string,
  border: PropTypes.string,
  loading: PropTypes.oneOf(['eager', 'lazy']),
};
